export type Plan = {
  id: "light" | "standard" | "pro";
  name: string;
  trafficGb: number;
  priceCny: number;
  validityDays: number;
  description: string;
  recommended?: boolean;
};

export type SupportedService = {
  id: string;
  name: string;
  category: "video" | "music" | "game";
  description: string;
};

export const plans: readonly Plan[] = [
  {
    id: "light",
    name: "轻量套餐",
    trafficGb: 30,
    priceCny: 12,
    validityDays: 30,
    description: "适合偶尔追剧、听歌和短期使用",
  },
  {
    id: "standard",
    name: "标准套餐",
    trafficGb: 100,
    priceCny: 30,
    validityDays: 30,
    description: "适合日常影音娱乐与稳定使用",
    recommended: true,
  },
  {
    id: "pro",
    name: "畅享套餐",
    trafficGb: 300,
    priceCny: 78,
    validityDays: 30,
    description: "适合高清影音与多设备重度使用",
  },
] as const;

export const supportedServices: readonly SupportedService[] = [
  { id: "tencent-video", name: "腾讯视频", category: "video", description: "热门影视、综艺与体育内容" },
  { id: "iqiyi", name: "爱奇艺", category: "video", description: "电视剧、电影与原创综艺" },
  { id: "youku", name: "优酷", category: "video", description: "国内热门剧集与综艺" },
  { id: "bilibili", name: "哔哩哔哩", category: "video", description: "视频、番剧与社区内容" },
  { id: "qq-music", name: "QQ音乐", category: "music", description: "华语歌曲、专辑与歌单" },
  { id: "netease-music", name: "网易云音乐", category: "music", description: "音乐、电台与个性歌单" },
  { id: "cn-games", name: "国服游戏", category: "game", description: "降低延迟，稳定连接国服" },
] as const;
